module.exports = __webpack_public_path__ + "img/vertical_1_1_9005.b8cb118f.png";